import {NgModule} from '@angular/core';
import {FaqComponent} from './faq.component';
import {RouterModule, Routes} from '@angular/router';
import {MatExpansionModule} from '@angular/material/expansion';
import {CommonSectionsModule} from '../views/common/common-sections.module';

const routes: Routes = [{
    path: '',
    component: FaqComponent
}];

@NgModule({
    exports: [RouterModule],
    imports: [RouterModule.forChild(routes)]
})
export class FaqRoutingModule {
}

@NgModule({
    declarations: [FaqComponent],
    imports: [MatExpansionModule, FaqRoutingModule, CommonSectionsModule]
})
export class FaqModule {
}
